module.exports = __webpack_public_path__ + "img/new_manager_curr.5d628541.jpg";